// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xx5tN","icon":"styles_icon__1QN7F"};